<template>
  <div>
    <base-header
      type="gradient-success"
      class="pb-5 pb-4 pt-4 pt-md-4 header_gradiant"
    >
    </base-header>
    <div class="container-fluid">
      <div class="card offset-xl-0 offset-lg-3 offset-md-4 shadow mb-3">
        <div class="row">
          <div class="col-md-2 mt-2">
            <div class="form-group">
              <nav aria-label="breadcrumb">
                <h3 style="color: #000; margin-left: 30px">Início</h3>
              </nav>
            </div>
          </div>
          <div class="col-md-5 offset-md-5 mt-2">
            <div class="form-group">
              <nav aria-label="breadcrumb">
                <h5 style="text-align: right; color: #000; margin-right: 30px">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-person-fill"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3Zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
                    />
                  </svg>
                  {{ state.nome }}
                </h5>
              </nav>
            </div>
          </div>
        </div>
        <div class="container">
          <div class="row">
            <div class="col-lg-4 col-md-6 col-12 card_box">
              <card
                :title="stats.visit.title"
                :value="state.clientes"
                :iconClass="stats.visit.iconClass"
                :iconBackground="stats.visit.iconBackground"
                directionReverse
              ></card>
            </div>
            <div class="col-lg-4 col-md-6 col-12 card_box">
              <card
                :title="stats.anuncios.title"
                :value="state.anuncios_pendentes"
                :iconClass="stats.anuncios.iconClass"
                :iconBackground="stats.anuncios.iconBackground"
                directionReverse
              ></card>
            </div>
            <div class="col-lg-4 col-md-6 col-12 card_box">
              <card
                :title="stats.anunciosAtivos.title"
                :value="state.anuncios_ativos"
                :iconClass="stats.anuncios.iconClass"
                :iconBackground="stats.anuncios.iconBackground"
                directionReverse
              ></card>
            </div>
            <div class="col-lg-4 col-md-6 col-12 card_box">
              <card
                :title="stats.propagandas.title"
                :value="state.propagandas_ativos"
                :iconClass="stats.propagandas.iconClass"
                :iconBackground="stats.propagandas.iconBackground"
                :percentageColor="stats.propagandas.percentageColor"
                directionReverse
              ></card>
            </div>
            <div class="col-lg-4 col-md-6 col-12 card_box">
              <card
                :title="stats.colunistas.title"
                :value="state.colunistas_cadastrados"
                :iconClass="stats.colunistas.iconClass"
                :iconBackground="stats.colunistas.iconBackground"
                directionReverse
              ></card>
            </div>
            <div class="col-lg-4 col-md-6 col-12 card_box">
              <card
                :title="stats.eventos.title"
                :value="state.eventos_futuros"
                :iconClass="stats.eventos.iconClass"
                :iconBackground="stats.eventos.iconBackground"
                directionReverse
              ></card>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Card from "@/examples/Cards/Card.vue";
import { onMounted, reactive } from "vue";
import services from "../../services";
import { useStorage } from "vue3-storage";
export default {
  name: "dashboard-default",
  data() {
    const storage = useStorage();
    var token = storage.getStorageSync("token");
    var nome = storage.getStorageSync("nome");
    const state = reactive({
      anuncios_pendentes: "",
      propagandas_ativos: "",
      colunistas_cadastrados: "",
      eventos_futuros: "",
      anuncios_ativos: "",
      nome: nome,
    });
    onMounted(() => {
      fetchInfos();
    });
    async function fetchInfos() {
      try {
        const { data } = await services.usuario.getInfos({ token });
        console.log(data);
        state.anuncios_pendentes = data.anuncios_pendentes;
        state.anuncios_ativos = data.anuncios_ativos;
        state.anuncios_ativos = data.anuncios_ativos;
        state.propagandas_ativos = data.propagandas_ativos;
        state.colunistas_cadastrados = data.colunistas_cadastrados;
        state.eventos_futuros = data.eventos_futuros;
      } catch (error) {
        console.log(error);
      }
    }
    return {
      stats: {
        visit: {
          title: "Visitas no Mês",
          iconClass: "fa fa-eye text-dark",
          iconBackground: "bg-gradient-success",
        },
        anuncios: {
          title: "Anuncios Pendentes",
          iconClass: "ni ni-notification-70 text-dark",
          iconBackground: "bg-gradient-success",
        },
        anunciosAtivos: {
          title: "Anuncios Ativos",
          iconClass: "ni ni-notification-70 text-dark",
          iconBackground: "bg-gradient-success",
        },
        propagandas: {
          title: "Propagandas Ativas",
          iconClass: "ni ni-tag text-dark",
          percentageColor: "text-danger",
          iconBackground: "bg-gradient-success",
        },
        colunistas: {
          title: "Colunistas Cadastrados",
          iconClass: "ni ni-glasses-2 text-dark",
          iconBackground: "bg-gradient-success ",
        },
        eventos: {
          title: "Eventos Futuros",
          iconClass: "ni ni-pin-3 text-dark",
          iconBackground: "bg-gradient-success ",
        },
      },
      state,
    };
  },
  components: {
    Card,
  },
};
</script>
<style scoped>
.card_box .card {
  box-shadow: 3px 3px 2px 0px rgba(0, 0, 0, 0.342);
}
svg {
  width: 30px;
  height: 30px;
}
@media (min-width: 992px) and (max-width: 1200px) {
  h3 {
    font-size: 18pt;
  }
}
@media (min-width: 768px) and (max-width: 991px) {
  h3 {
    font-size: 16pt;
    margin-left: 6px;
  }
}
@media (min-width: 576px) and (max-width: 767px) {
}
@media (max-width: 575px) {
}
</style>